import moment from 'moment';

export const formatDateToDDMMYYYY = (date?: string) => {
  if (!date) return '';

  const parsedDate = moment(
    date,
    [moment.ISO_8601, 'YYYY-MM-DD', 'DD-MM-YYYY'],
    true
  );

  return parsedDate.isValid() ? parsedDate.format('DD/MM/YYYY') : '';
};
